import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://csksportswear.in/backend/api';

function Home() {
  const [products, setProducts] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [settings, setSettings] = useState({});
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightbox, setLightbox] = useState(null);
  const [contactForm, setContactForm] = useState({ name: '', phone: '', message: '' });
  const [formStatus, setFormStatus] = useState('');

  const categories = ['All', 'Cricket', 'Football', 'Badminton', 'Basketball', 'Track & Field', 'Custom'];

  useEffect(() => {
    fetchSettings();
    fetchProducts();
    fetchGallery();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${API}/settings.php?action=public`);
      if (res.data.success) setSettings(res.data.data);
    } catch (err) { console.error(err); }
  };

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${API}/products.php?action=list`);
      if (res.data.success) setProducts(res.data.data);
    } catch (err) { console.error(err); }
  };

  const fetchGallery = async () => {
    try {
      const res = await axios.get(`${API}/gallery.php?action=public`);
      if (res.data.success) setGallery(res.data.data.slice(0, 12));
    } catch (err) { console.error(err); }
  };

  const filteredProducts = activeCategory === 'All'
    ? products.slice(0, 12)
    : products.filter(p => p.category_name === activeCategory).slice(0, 12);

  const handleWhatsApp = (product) => {
    const num = settings.whatsapp_number || '918248206056';
    const msg = encodeURIComponent(`Hi CSK Sportswear! I'm interested in *${product.name}* priced at ₹${product.price}. Please share more details.`);
    window.open(`https://wa.me/${num}?text=${msg}`, '_blank');
  };

  const handleContact = async () => {
    if (!contactForm.name || !contactForm.phone || !contactForm.message) {
      setFormStatus('error');
      return;
    }
    try {
      const res = await axios.post(`${API}/enquiries.php?action=submit`, {
        name: contactForm.name,
        phone: contactForm.phone,
        message: contactForm.message,
      });
      if (res.data.success) {
        setFormStatus('success');
        setContactForm({ name: '', phone: '', message: '' });
        setTimeout(() => setFormStatus(''), 5000);
      }
    } catch (err) {
      // WhatsApp fallback
      const num = settings.whatsapp_number || '918248206056';
      const msg = encodeURIComponent(`New Enquiry!%0A%0AName: ${contactForm.name}%0APhone: ${contactForm.phone}%0AMessage: ${contactForm.message}`);
      window.open(`https://wa.me/${num}?text=${msg}`, '_blank');
      setFormStatus('success');
      setContactForm({ name: '', phone: '', message: '' });
    }
  };

  const s = settings;

  return (
    <div style={{ fontFamily: 'Inter, sans-serif', background: '#0A0A0A', color: 'white' }}>
      <style>{`
        .section { padding: 80px 0; }
        .container { max-width: 1280px; margin: 0 auto; padding: 0 24px; }
        @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .marquee-track { display: inline-block; animation: marquee 25s linear infinite; white-space: nowrap; }
        @keyframes floatLogo { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-20px); } }
        @media (max-width: 768px) {
          .section { padding: 60px 0; }
          .hero-title { font-size: 40px !important; }
          .hero-subtitle { font-size: 16px !important; }
          .hero-btns { flex-direction: column !important; }
          .hero-btns button { width: 100% !important; }
          .hero-logo { display: none !important; }
          .stats-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .products-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .gallery-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .about-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
          .about-stats { grid-template-columns: repeat(2, 1fr) !important; }
          .contact-grid { grid-template-columns: 1fr !important; }
          .features-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 480px) {
          .products-grid { grid-template-columns: 1fr 1fr !important; }
          .gallery-grid { grid-template-columns: 1fr 1fr !important; }
        }
        .cat-btn { padding: 8px 20px; border-radius: 50px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.04); color: rgba(255,255,255,0.7); font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap; transition: all 0.2s; font-family: Inter, sans-serif; }
        .cat-btn:hover { border-color: rgba(0,102,255,0.4); color: white; }
        .cat-btn.active { background: #0066FF; border-color: #0066FF; color: white; }
        .product-card { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; overflow: hidden; transition: all 0.3s; }
        .product-card:hover { border-color: rgba(0,102,255,0.3); transform: translateY(-4px); box-shadow: 0 20px 40px rgba(0,0,0,0.3); }
        .gal-item { position: relative; border-radius: 12px; overflow: hidden; aspect-ratio: 1; cursor: pointer; background: rgba(255,255,255,0.03); }
        .gal-item img, .gal-item video { width: 100%; height: 100%; object-fit: cover; }
        .gal-item:hover .gal-hover { opacity: 1 !important; }
        .gal-hover { position: absolute; inset: 0; background: rgba(0,102,255,0.5); opacity: 0; transition: opacity 0.2s; display: flex; align-items: center; justify-content: center; font-size: 32px; }
        .input-field { width: 100%; padding: 14px 16px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 10px; color: white; font-size: 14px; outline: none; box-sizing: border-box; font-family: Inter, sans-serif; transition: border-color 0.2s; }
        .input-field:focus { border-color: rgba(0,102,255,0.5); }
        .wa-float { position: fixed; bottom: 24px; right: 24px; z-index: 998; width: 56px; height: 56px; background: #25D366; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 28px; cursor: pointer; box-shadow: 0 4px 20px rgba(37,211,102,0.4); transition: transform 0.2s; border: none; }
        .wa-float:hover { transform: scale(1.1); }
        .feature-card { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 28px; transition: all 0.3s; }
        .feature-card:hover { border-color: rgba(0,102,255,0.3); background: rgba(0,102,255,0.04); }
      `}</style>

      {/* ── HERO ── */}
      <section id="hero" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', position: 'relative', overflow: 'hidden', paddingTop: '80px' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 20% 50%, rgba(0,102,255,0.15) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(220,38,38,0.1) 0%, transparent 50%)' }} />
        <div style={{ position: 'absolute', top: '10%', right: '5%', width: '500px', height: '500px', background: 'rgba(0,102,255,0.05)', borderRadius: '50%', filter: 'blur(80px)' }} />
        <div className="container" style={{ position: 'relative', zIndex: 1, width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '40px' }}>
            {/* Left */}
            <div style={{ flex: 1, maxWidth: '620px' }}>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(0,102,255,0.1)', border: '1px solid rgba(0,102,255,0.2)', borderRadius: '50px', padding: '6px 16px', marginBottom: '24px' }}>
                <span style={{ width: '6px', height: '6px', background: '#16A34A', borderRadius: '50%', display: 'inline-block' }} />
                <span style={{ fontSize: '12px', color: '#94A3B8', letterSpacing: '1px', fontWeight: 600 }}>
                  {s.hero_badge || "CHENNAI'S PREMIER SPORTS WEAR"}
                </span>
              </div>
              <h1 className="hero-title" style={{ fontFamily: 'Montserrat', fontSize: '64px', fontWeight: 900, lineHeight: 1.1, marginBottom: '24px', letterSpacing: '-1px', whiteSpace: 'pre-line' }}>
                {s.hero_title ? s.hero_title.replace(/\\n/g, '\n') : 'WEAR THE\nCHAMPION\nSPIRIT'}
              </h1>
              <p className="hero-subtitle" style={{ fontSize: '18px', color: '#94A3B8', marginBottom: '40px', lineHeight: 1.7, maxWidth: '500px' }}>
                {s.hero_subtitle || 'Custom sports jerseys, kits, and equipment for teams, clubs, and athletes across Tamil Nadu.'}
              </p>
              <div className="hero-btns" style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <button onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })} style={{ background: 'linear-gradient(135deg, #0066FF, #0052CC)', color: 'white', padding: '16px 36px', borderRadius: '10px', fontSize: '16px', fontWeight: 700, border: 'none', cursor: 'pointer' }}>
                  {s.hero_btn1 || 'Shop Now'} →
                </button>
                <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} style={{ background: 'rgba(255,255,255,0.06)', color: 'white', padding: '16px 36px', borderRadius: '10px', fontSize: '16px', fontWeight: 700, border: '1px solid rgba(255,255,255,0.1)', cursor: 'pointer' }}>
                  {s.hero_btn2 || 'Get Quote'}
                </button>
              </div>
              <div className="stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px', marginTop: '64px', paddingTop: '48px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
                {[
                  { number: s.stats_teams || '500+', label: 'Teams Served' },
                  { number: s.stats_jerseys || '10K+', label: 'Jerseys Delivered' },
                  { number: s.stats_sports || '15+', label: 'Sports' },
                  { number: s.stats_rating || '5★', label: 'Rating' },
                ].map((stat, i) => (
                  <div key={i}>
                    <div style={{ fontFamily: 'Montserrat', fontSize: '28px', fontWeight: 900, color: '#0066FF', marginBottom: '4px' }}>{stat.number}</div>
                    <div style={{ fontSize: '13px', color: '#475569' }}>{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
            {/* Right Logo */}
            {s.site_logo && (
              <div className="hero-logo" style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={s.site_logo} alt={s.site_name || 'CSK'} style={{ width: '400px', height: '400px', objectFit: 'contain', filter: 'drop-shadow(0 0 60px rgba(0,102,255,0.25))', animation: 'floatLogo 4s ease-in-out infinite', mixBlendMode: 'screen' }} />
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ── MARQUEE ── */}
      <div style={{ background: '#0066FF', padding: '12px 0', overflow: 'hidden', whiteSpace: 'nowrap' }}>
        <div className="marquee-track">
          {[...Array(4)].map((_, i) => (
            <span key={i} style={{ fontSize: '13px', fontWeight: 700, letterSpacing: '2px', marginRight: '60px' }}>
              {s.marquee_text || '★ CRICKET JERSEY ★ FOOTBALL KIT ★ BADMINTON WEAR ★ CUSTOM PRINTING ★ BULK ORDERS'}
              &nbsp;&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>

      {/* ── WHY CHOOSE ── */}
      <section className="section" style={{ background: 'rgba(255,255,255,0.01)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h2 style={{ fontFamily: 'Montserrat', fontSize: '36px', fontWeight: 800 }}>Why Choose CSK?</h2>
            <p style={{ color: '#475569', marginTop: '8px' }}>Quality you can trust, prices you'll love</p>
          </div>
          <div className="features-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            {[
              { icon: '🏆', title: 'Premium Quality', desc: 'High-grade fabrics and materials that last through intense training and matches.' },
              { icon: '🎨', title: 'Custom Design', desc: 'Your logo, colors, and numbers. We bring your team identity to life.' },
              { icon: '⚡', title: 'Fast Delivery', desc: 'Quick turnaround times — even for bulk orders. Ready when you need it.' },
              { icon: '💰', title: 'Best Prices', desc: 'Factory-direct pricing with no middlemen. Bulk discounts available.' },
              { icon: '📐', title: 'Perfect Fit', desc: 'All sizes from XS to 3XL. Custom measurements available on request.' },
              { icon: '🤝', title: 'Trusted Partner', desc: '500+ teams across Tamil Nadu trust CSK for their sportswear needs.' },
            ].map((f, i) => (
              <div key={i} className="feature-card">
                <div style={{ fontSize: '36px', marginBottom: '16px' }}>{f.icon}</div>
                <h3 style={{ fontFamily: 'Montserrat', fontSize: '16px', fontWeight: 700, marginBottom: '8px' }}>{f.title}</h3>
                <p style={{ color: '#475569', fontSize: '14px', lineHeight: 1.6 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PRODUCTS ── */}
      <section id="products" className="section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '16px' }}>
            <h2 style={{ fontFamily: 'Montserrat', fontSize: '36px', fontWeight: 800 }}>Our Products</h2>
            <p style={{ color: '#475569', marginTop: '8px', marginBottom: '32px' }}>Premium sportswear for every athlete</p>
          </div>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '32px', flexWrap: 'wrap', justifyContent: 'center', overflowX: 'auto' }}>
            {categories.map(cat => (
              <button key={cat} className={`cat-btn ${activeCategory === cat ? 'active' : ''}`} onClick={() => setActiveCategory(cat)}>{cat}</button>
            ))}
          </div>
          {filteredProducts.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px', color: '#475569' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📦</div>
              <div>No products yet</div>
            </div>
          ) : (
            <div className="products-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px' }}>
              {filteredProducts.map(p => (
                <div key={p.id} className="product-card">
                  <div style={{ background: 'rgba(255,255,255,0.04)', height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,0.06)', position: 'relative', overflow: 'hidden' }}>
                    {p.image ? (
                      <img src={p.image} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '48px', marginBottom: '8px' }}>👕</div>
                        <div style={{ fontSize: '11px', color: '#475569' }}>{p.category_name}</div>
                      </div>
                    )}
                    <div style={{ position: 'absolute', top: '12px', left: '12px', background: '#0066FF', color: 'white', padding: '3px 10px', borderRadius: '50px', fontSize: '10px', fontWeight: 700 }}>
                      {p.category_name}
                    </div>
                  </div>
                  <div style={{ padding: '16px' }}>
                    <h3 style={{ fontFamily: 'Montserrat', fontSize: '15px', fontWeight: 700, marginBottom: '8px', color: 'white' }}>{p.name}</h3>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                      <div style={{ fontSize: '20px', fontWeight: 800, color: '#0066FF' }}>₹{parseFloat(p.price).toFixed(0)}</div>
                      <div style={{ fontSize: '11px', color: p.stock > 0 ? '#16A34A' : '#DC2626', fontWeight: 600 }}>
                        {p.stock > 0 ? 'In Stock' : 'Out of Stock'}
                      </div>
                    </div>
                    <button onClick={() => handleWhatsApp(p)} style={{ width: '100%', padding: '10px', background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.3)', borderRadius: '8px', color: '#25D366', fontSize: '13px', fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', fontFamily: 'Inter, sans-serif' }}>
                      💬 Enquire on WhatsApp
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ── GALLERY ── */}
      <section id="gallery" className="section" style={{ background: 'rgba(255,255,255,0.01)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h2 style={{ fontFamily: 'Montserrat', fontSize: '36px', fontWeight: 800 }}>Gallery</h2>
            <p style={{ color: '#475569', marginTop: '8px' }}>Our work in action</p>
          </div>
          {gallery.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px', color: '#475569' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>🖼️</div>
              <div>Gallery coming soon</div>
            </div>
          ) : (
            <div className="gallery-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
              {gallery.map(item => (
                <div key={item.id} className="gal-item" onClick={() => setLightbox(item)}>
                  {item.file_type === 'image' ? (
                    <img src={item.file_url} alt={item.title} onError={e => e.target.style.display = 'none'} />
                  ) : (
                    <video src={item.file_url} muted />
                  )}
                  <div className="gal-hover">{item.file_type === 'video' ? '▶️' : '🔍'}</div>
                  {item.file_type === 'video' && (
                    <div style={{ position: 'absolute', top: '8px', right: '8px', background: 'rgba(139,92,246,0.9)', color: 'white', padding: '2px 8px', borderRadius: '50px', fontSize: '10px', fontWeight: 700 }}>🎥</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section id="about" className="section">
        <div className="container">
          <div className="about-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }}>
            <div>
              <div style={{ display: 'inline-block', background: 'rgba(0,102,255,0.1)', border: '1px solid rgba(0,102,255,0.2)', borderRadius: '50px', padding: '6px 16px', marginBottom: '20px', fontSize: '12px', color: '#0066FF', fontWeight: 600, letterSpacing: '1px' }}>ABOUT US</div>
              <h2 style={{ fontFamily: 'Montserrat', fontSize: '36px', fontWeight: 800, marginBottom: '20px', lineHeight: 1.2 }}>
                {s.about_title || "Chennai's Trusted Sportswear Brand"}
              </h2>
              <p style={{ color: '#94A3B8', fontSize: '15px', lineHeight: 1.8, marginBottom: '16px' }}>
                {s.about_content || 'CSK Sportswear has been crafting premium quality sports uniforms and equipment for teams across Tamil Nadu.'}
              </p>
              {s.about_content2 && (
                <p style={{ color: '#94A3B8', fontSize: '15px', lineHeight: 1.8, marginBottom: '24px' }}>{s.about_content2}</p>
              )}
              <div style={{ marginBottom: '24px' }}>
                {[
                  { label: 'Founded', value: s.founded || '2015' },
                  { label: 'Location', value: s.location || 'Chennai, Tamil Nadu' },
                  { label: 'Speciality', value: s.speciality || 'Custom Sports Uniforms' },
                ].map((item, i) => (
                  <div key={i} style={{ display: 'flex', gap: '16px', marginBottom: '10px' }}>
                    <span style={{ color: '#0066FF', fontWeight: 700, minWidth: '90px', fontSize: '13px' }}>{item.label}:</span>
                    <span style={{ color: 'white', fontSize: '13px' }}>{item.value}</span>
                  </div>
                ))}
              </div>
              <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} style={{ background: 'linear-gradient(135deg, #0066FF, #0052CC)', color: 'white', padding: '14px 32px', borderRadius: '8px', fontSize: '14px', fontWeight: 700, border: 'none', cursor: 'pointer' }}>
                Contact Us →
              </button>
            </div>
            <div className="about-stats" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              {[
                { icon: '🏟️', number: s.stats_teams || '500+', label: 'Teams Served' },
                { icon: '👕', number: s.stats_jerseys || '10K+', label: 'Jerseys Made' },
                { icon: '🎨', number: '100%', label: 'Custom Made' },
                { icon: '⭐', number: s.stats_rating || '5★', label: 'Avg Rating' },
              ].map((stat, i) => (
                <div key={i} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '16px', padding: '28px 20px', textAlign: 'center' }}>
                  <div style={{ fontSize: '32px', marginBottom: '12px' }}>{stat.icon}</div>
                  <div style={{ fontFamily: 'Montserrat', fontSize: '28px', fontWeight: 900, color: '#0066FF', marginBottom: '6px' }}>{stat.number}</div>
                  <div style={{ fontSize: '13px', color: '#475569' }}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── CONTACT ── */}
      <section id="contact" className="section" style={{ background: 'rgba(255,255,255,0.01)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h2 style={{ fontFamily: 'Montserrat', fontSize: '36px', fontWeight: 800 }}>Get In Touch</h2>
            <p style={{ color: '#475569', marginTop: '8px' }}>We'd love to hear from you!</p>
          </div>
          <div className="contact-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '48px' }}>
            {/* Info */}
            <div>
              <h3 style={{ fontFamily: 'Montserrat', fontSize: '22px', fontWeight: 700, marginBottom: '24px' }}>Contact Information</h3>
              {[
                { icon: '📍', label: 'Address', value: s.address || 'Chennai, Tamil Nadu, India' },
                { icon: '📞', label: 'Phone', value: s.phone || '+91 9XXXXXXXXX' },
                { icon: '✉️', label: 'Email', value: s.email || 'info@csksportswear.com' },
                { icon: '🕒', label: 'Hours', value: s.working_hours || 'Mon–Sat: 9AM – 6PM' },
              ].map((c, i) => (
                <div key={i} style={{ display: 'flex', gap: '16px', marginBottom: '20px', alignItems: 'flex-start' }}>
                  <div style={{ width: '44px', height: '44px', background: 'rgba(0,102,255,0.1)', border: '1px solid rgba(0,102,255,0.2)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>
                    {c.icon}
                  </div>
                  <div>
                    <div style={{ fontSize: '12px', color: '#475569', marginBottom: '4px', fontWeight: 600 }}>{c.label}</div>
                    <div style={{ fontSize: '14px', color: 'white' }}>{c.value}</div>
                  </div>
                </div>
              ))}
              <button onClick={() => window.open(`https://wa.me/${s.whatsapp_number || '918248206056'}`, '_blank')} style={{ marginTop: '16px', background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.3)', color: '#25D366', padding: '14px 28px', borderRadius: '8px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontFamily: 'Inter, sans-serif' }}>
                💬 Chat on WhatsApp
              </button>
            </div>
            {/* Form */}
            <div>
              <h3 style={{ fontFamily: 'Montserrat', fontSize: '22px', fontWeight: 700, marginBottom: '24px' }}>Send a Message</h3>
              {formStatus === 'success' && (
                <div style={{ background: 'rgba(22,163,74,0.1)', border: '1px solid rgba(22,163,74,0.3)', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', color: '#16A34A', fontSize: '13px', fontWeight: 600 }}>
                  ✅ Message sent! We'll get back to you soon.
                </div>
              )}
              {formStatus === 'error' && (
                <div style={{ background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', color: '#DC2626', fontSize: '13px', fontWeight: 600 }}>
                  ❌ Please fill all fields.
                </div>
              )}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <input type="text" placeholder="Your Name *" value={contactForm.name} onChange={e => setContactForm({ ...contactForm, name: e.target.value })} className="input-field" />
                <input type="tel" placeholder="Phone Number *" value={contactForm.phone} onChange={e => setContactForm({ ...contactForm, phone: e.target.value })} className="input-field" />
                <textarea placeholder="Your Message *" value={contactForm.message} onChange={e => setContactForm({ ...contactForm, message: e.target.value })} rows={5} className="input-field" style={{ resize: 'none' }} />
                <button onClick={handleContact} style={{ background: 'linear-gradient(135deg, #0066FF, #0052CC)', color: 'white', padding: '14px', borderRadius: '8px', fontSize: '15px', fontWeight: 700, border: 'none', cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
                  Send Message →
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={{ background: '#000', borderTop: '1px solid rgba(255,255,255,0.08)', padding: '40px 0' }}>
        <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              {s.site_logo ? (
                <img src={s.site_logo} alt="logo" style={{ height: '32px', objectFit: 'contain', mixBlendMode: 'screen' }} />
              ) : (
                <span style={{ color: '#DC2626', fontSize: '22px' }}>★</span>
              )}
              <div>
                <div style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 900, letterSpacing: '3px', color: 'white' }}>{s.site_name || 'CSK SPORTSWEAR'}</div>
                <div style={{ fontSize: '11px', color: '#475569' }}>{s.footer_tagline || 'Chennai, Tamil Nadu'}</div>
              </div>
            </div>
            <div style={{ color: '#475569', fontSize: '13px' }}>{s.footer_text || '© 2026 CSK Sportswear. All rights reserved.'}</div>
            <div style={{ color: '#475569', fontSize: '12px' }}>{s.dev_credit || <span>Powered by <span style={{ color: '#0066FF' }}>Veltrix Technologies</span></span>}</div>
          </div>
        </div>
      </footer>

      {/* WhatsApp Float */}
      <button className="wa-float" onClick={() => window.open(`https://wa.me/${s.whatsapp_number || '918248206056'}`, '_blank')} title="Chat on WhatsApp">
        💬
      </button>

      {/* Lightbox */}
      {lightbox && (
        <div onClick={() => setLightbox(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.95)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: '16px', cursor: 'pointer' }}>
          <button onClick={() => setLightbox(null)} style={{ position: 'absolute', top: '16px', right: '16px', background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', width: '44px', height: '44px', color: 'white', fontSize: '20px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
          <div onClick={e => e.stopPropagation()}>
            {lightbox.file_type === 'image' ? (
              <img src={lightbox.file_url} alt={lightbox.title} style={{ maxWidth: '90vw', maxHeight: '85vh', objectFit: 'contain', borderRadius: '8px' }} />
            ) : (
              <video src={lightbox.file_url} controls autoPlay style={{ maxWidth: '90vw', maxHeight: '85vh', borderRadius: '8px' }} />
            )}
            {lightbox.title && <div style={{ textAlign: 'center', marginTop: '12px', color: 'white', fontWeight: 600 }}>{lightbox.title}</div>}
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;
